'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var ClearButton = require('../../../buttons/ClearButton/ClearButton.js');
var styledComponents = require('./styled-components.js');

var DrawerHeader = function (props) {
    var title = props.title, closeDrawer = props.closeDrawer;
    if (typeof title === 'string') {
        return (React__default.createElement(styledComponents.Main, null,
            React__default.createElement(core.Typography, { variant: 'h2' }, title),
            React__default.createElement(ClearButton, { onClick: closeDrawer })));
    }
    return (React__default.createElement(styledComponents.Main, null,
        title,
        React__default.createElement(ClearButton, { onClick: closeDrawer })));
};

module.exports = DrawerHeader;
